import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgDataAnalyticsIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20 20H5.4222c-.4978 0-.7467 0-.9369-.0969a.89.89 0 0 1-.3884-.3884C4 19.3245 4 19.0756 4 18.5778V4m16 3.5556-4.8305 4.8305c-.176.176-.264.264-.3655.2969a.445.445 0 0 1-.2747 0c-.1015-.0329-.1895-.1209-.3655-.2969l-1.661-1.661c-.176-.1761-.264-.2641-.3655-.297a.444.444 0 0 0-.2746 0c-.1015.0329-.1895.1209-.3655.297l-3.9416 3.9416M20 7.5556h-3.5556m3.5556 0v3.5555"
    />
  </svg>
);
export default SvgDataAnalyticsIcon;
